import { Component } from '@angular/core';
import { ItemsListRowItemBase } from '@fi-app/components/items-list/list-row/list-row-item/list-row-item-base';

@Component({
    selector: 'fi-tag-list-column-module-names',
    template: `<fi-tag-module-type-names [tag]="data"></fi-tag-module-type-names>`,
    standalone: false,
})
export class FiTagListColumnModuleNamesComponent extends ItemsListRowItemBase {}
